/**
 * @file 接口请求
 * @author congpeisen@baidu.com
 */

/* globals swan, getApp */

/* eslint-disable */
import { act } from './navigate';
import { getQueryStr, extend, getApiInfo } from './core';
import * as log from '../../common/js/log';
import { setExpFromHeader, setExpResult } from '../../common/js/experiment';
import { EXP_HOST_HEADER, handleHost } from '../../static/utils/env';

// 获取BDUSS
export const getBDUSS = () => {
  return new Promise(resolve => {
    resolve({
      bduss: ''
    });
  });
};

// 获取baduid、sid
let _getCommonSysInfo = () => {
  return new Promise(resolve => {
    resolve({
      baidu_id: '',
      sid: ''
    });
  });
};

// 获取host
let _getSysInfo = () => {
  return new Promise(resolve => {
    resolve({
      host: ''
    });
  });
};
let _reqWithSign = ({
  url,
  data,
  defer,
  loginNeeded = true,
  method,
  needBduss,
  header,
  isExtra = true,
  isQtest = false
}) => {
  // 预先拼接一些请求参数
  // 兼容post请求
  // 统一拼在请求里的数据
  let extData = {
    city: getApp().globalData.location.cityName || ''
  };
  header = header || {};
  // url中不含clientType的话，添加clientType
  if (url.indexOf('clientType=') === -1) {
    extData.clientType = "h5";
  }
  if (method && method.toLowerCase() === 'post') {
    // token和scene为get参数，post请求参数里data会放在response body里
    url = url.indexOf('?') > -1 ? `${url}&${getQueryStr(extData)}` : `${url}?${getQueryStr(extData)}`;
  } else {
    data = isExtra ? extend({}, extData, data) : data;
  }
  return new Promise(resolve => {
    resolve(getApp().$api.request({
      url,
      header: {
        ...header,
        'x-swan-version': '1.26.14'
      },
      data,
      method
    }));
  });
};

// 获取首屏数据
export let getData = ({
  url,
  data,
  defer = false,
  loginNeeded = true,
  autoJumpLogin = true,
  needBduss,
  header,
  loginSuccessCallBack = () => {},
  loginFailCallBack = () => {},
  isQtest = false
}) => {
  let reqStart = Date.now();
  return _reqWithSign({
    url,
    data,
    defer,
    loginNeeded,
    needBduss,
    header
  }).then(d => {
    d.header && setExpFromHeader(d.header);
    if (url && url.indexOf('/falv/') > -1) {
      d.data && d.data.expVarTags && setExpResult(d.data.expVarTags);
    } else {
      d.data && d.data.data && d.data.data.lawExpTags && setExpResult(d.data.data.lawExpTags);
    }
    // 统一数据预处理
    if (!d.data || +d.data.status !== 0 && +d.data.code !== 0) {
      return;
    }
    let data = d.data.data;

    // 跳转错误页
    if (data._page && data._page.PageStatus !== 0) {
      data._page.href = `${window.location.pathname}${window.location.search}`;
      act({
        type: 'page-error',
        target: data._page
      });
      return;
    }
    try {
      const ss = {
        info: {},
        dim: {},
        group: ''
      };
      const reqTime = new Date().getTime() - reqStart;
      const ApiInfo = getApiInfo(url);
      if (ApiInfo) {
        const {
          path,
          group
        } = ApiInfo;
        ss.group = group;
        if (group === 'rd_domainapi') {
          ss.info[path] = reqTime;
        } else if (group === 'online_city') {
          ss.info.city = reqTime;
        } else {
          ss.info[path] = reqTime;
        }
        log.sendWebb(ss);
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
    }

    return data;
  }).catch(() => {
    if (!autoJumpLogin) {
      return new Promise(resolve => {
        resolve(getApp().$api.request({
          url,
          data
        }));
      }).then(d => {
        // 统一数据预处理
        if (!d.data || d.data.status !== 0) {
          return;
        }
        return d.data.data;
      });
    }
  });
};

// 请求异步接口（携带登录态参数的请求）
export let request = ({
  url,
  data,
  defer,
  loginNeeded,
  needBduss,
  method,
  header,
  isExtra,
  isQtest = false
}) => {
  return new Promise((resolve, reject) => {
    _reqWithSign({
      url,
      data,
      defer,
      loginNeeded,
      method,
      needBduss,
      header,
      isExtra,
      isQtest
    }).then(res => {
      res.header && setExpFromHeader(res.header);
      if (url && url.indexOf('/swan/') > -1) {
        res.data && res.data.lawExpTags && setExpResult(res.data.lawExpTags);
      } else {
        res.data && res.data.expVarTags && setExpResult(res.data.expVarTags);
      }
      resolve(res);
    }).catch(err => {
      reject(err);
    });
  });
  // return _reqWithSign({url, data, defer, loginNeeded, method, needBduss, header, isExtra});
};